import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

import { ControlButton } from '../ControlButton'
import { useShallow } from 'zustand/react/shallow'
import { useCADQuery } from '@/services/queries/cads'
import { useCADPageStore, SectionState } from '@/state'
import { ResetIcon } from '@/components/icons/ResetIcon'

export const ResetSectionButton = () => {
  const setCadPageState = useCADPageStore(useShallow((state) => state.setState))
  const { isLoading, data: cadData } = useCADQuery()
  const gltf = cadData.gltf

  if (isLoading || !gltf) return null

  return (
    <DropdownMenuItem>
      <ControlButton
        icon={<ResetIcon className="w-5 h-5" />}
        title="Reset"
        onClick={() => {
          gltf.resetClippingPlanes()
          setCadPageState({
            clippingPlanes: [],
            isEditModeActive: false,
            sectionState: SectionState.RESET,
          })
        }}
      />
    </DropdownMenuItem>
  )
}
